import React, { useContext } from 'react'
import { MenuItem, Theme, SxProps } from '@mui/material'
import { DropdownContext } from '.'

/**
 * @typedef {Object} CustomDropdownProps
 * @property {React.ReactNode} children
 * @property {SxProps<Theme>} sx
 */

/**
 * @param {CustomDropdownProps} param0
 * @returns {JSX.Element} Dropdown component
 */

const DropdownMenuItem = ({ children, ...props }) => {
const { handleClose } = useContext(DropdownContext);

  return (
      <MenuItem
        disableRipple
        {...props}
        onClick={(e) => {
          props?.onClick?.(e);
          handleClose();
        }}
      >
        {children}
      </MenuItem>
  )
}

export default DropdownMenuItem